import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useFreshContent = (page) => {
  const [c, setC] = useState(null);
  useEffect(() => {
    let live = true;
    fetch(`${API}/public/site-content/${page}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((x) => { if (live) setC(x?.data || null); })
      .catch(() => {});
    return () => { live = false; };
  }, [page]);
  return c;
};
